import {createAsyncThunk, createSlice, createEntityAdapter, createSelector} from '@reduxjs/toolkit';
import {ratesKey} from "./entities";
import { callGraphQL, callGraphQLv2 } from "./api.slice";

export const fetchDisplayPrices = createAsyncThunk(`${ratesKey}/getRatesDisplayPrices`, async ({ rateIds }, context) => {
    const request = {
        query: `
            query getRatesDisplayPrices(
                $rateIds: [String!]!,
            ) {
                getRatesDisplayPrices(
                    rateIds: $rateIds,
                ) {
                    rateId,
                    displayPrice
                }
            }
        `,
        variables: { rateIds },
        isPublic: true,
    };
    const { type, payload, error } = await context.dispatch(callGraphQLv2(request));

    return type.endsWith('rejected') ?
        context.rejectWithValue(payload || error) :
        payload.getRatesDisplayPrices;
});

export const fetchRateAccessDevices = createAsyncThunk(`${ratesKey}/getRateAccessDevices`, async ({ rateId, parkerStartDate }, context) => {
    const request = {
        query: `
            query getRateAccessDevices(
                $rateId: String!,
                $parkerStartDate: String!
            ) {
                getRateAccessDevices(
                    rateId: $rateId,
                    parkerStartDate: $parkerStartDate
                ) {
                    id,
                    required,
                    type,
                    price,
                    tax1,
                    tax2,
                    tax3,
                    tax4
                }
            }
        `,
        variables: { rateId, parkerStartDate },
        isPublic: true,
    };
    const { type, payload, error } = await context.dispatch(callGraphQLv2(request));

    return type.endsWith('rejected') ?
        context.rejectWithValue(payload || error) :
        payload.getRateAccessDevices;
});

export const fetchBillingSummary = createAsyncThunk(`${ratesKey}/getCheckoutBillingSummary`, async ({ parkers, subscriptionId, includeCreditCardFees }, context) => {
    const request = {
        query: `
            query getCheckoutBillingSummary(
                $parkers: [BillingSummaryParkerInput]!,
                $subscriptionId: String,
                $includeCreditCardFees: Boolean!
            ) {
                getCheckoutBillingSummary(
                    parkers: $parkers,
                    subscriptionId: $subscriptionId,
                    includeCreditCardFees: $includeCreditCardFees
                ) {
                    totals {
                        initial {
                            total,
                            price,
                            taxes,
                            items {
                                type,
                                label,
                                price,
                                taxes,
                                total
                            },
                        },
                        recurring {
                            total,
                            price,
                            taxes,
                            items {
                                type,
                                label,
                                price,
                                taxes,
                                total
                            },
                        }
                    },
                    parkers {
                        id,
                        name,
                        startDate,
                        initial {
                            total,
                            price,
                            taxes,
                            items {
                                type,
                                label,
                                price,
                                taxes,
                                total
                            },
                        },
                        recurring {
                            total,
                            price,
                            taxes,
                            items {
                                type,
                                label,
                                price,
                                taxes,
                                total
                            },
                        }
                    }
                }
            }
        `,
        variables: { parkers, subscriptionId, includeCreditCardFees },
        isPublic: true,
    };

    const { type, payload, error } = await context.dispatch(callGraphQLv2(request));

    return type.endsWith('rejected') ?
        context.rejectWithValue(payload || error) :
        payload.getCheckoutBillingSummary;
});


const adapter = createEntityAdapter();
const slice = createSlice({
   name: ratesKey,
   initialState: adapter.getInitialState(),
   reducers: {},
   extraReducers: {
      // [fetchBillingProfiles.fulfilled]: (state, {meta: {arg}, payload}) => {
      //    if (payload[ratesKey]) {
      //       // console.log(payload[ratesKey], arg);
      //    }
      //    return state;
      // },
      [callGraphQL.fulfilled]: (state, {payload}) => {
         if (payload[ratesKey]) adapter.upsertMany(state, payload[ratesKey]);
      },
   }
});
const reducer = slice.reducer;
export default reducer;
export const selectRates = state => state[ratesKey];
export const {
   selectById: rateById,
   selectIds: rateIds,
   selectEntities: ratesMap,
   selectAll: allRates,
   selectTotal: ratesCount
} = adapter.getSelectors(selectRates)
export const  ratesByBillingProfile = () => createSelector(
    allRates,
    (_, billingProfileId) => billingProfileId,
    (rates, billingProfileId) => billingProfileId ? rates.filter(rate => rate.billing_profile_id === billingProfileId) : rates
)
// const extraReducers = {
//    [fetchRates.pending]: state => {
//       state.loading = false;
//       state.errors = null;
//    },
//    [fetchRates.rejected]: (state, action) => {
//       state.loading = false;
//       state.errors = action.errors;
//    },
//    [fetchRates.fulfilled]: (state, action) => {
//
//    }
// }
// const extraReducers = builder => {
//    builder.addCase(fetchRates.pending, state => {
//       state.loading = true;
//       state.errors = null;
//    })
//    builder.addCase(fetchRates.rejected, (state, action) => {
//       state.loading = false;
//       state.errors = action.payload;
//    });
//    builder.addCase(fetchRates.fulfilled, (state, action) => {
//       state.loading = false;
//       adapter.upsertMany(state, action.payload)
//    });
// }
// export const fetchRates = createAsyncThunk(`${name}/fetchAll`, fetchAllRates);
